import { ConfirmModal, Textarea, showToast } from '@lokalise/louis';
import { useEffect, useRef, useState } from 'react';

import type { StyleGuide } from '@app/api/styleGuide';

import { useStyleGuideContext } from '../../StyleGuideContext';

export const EditSummaryModal = ({ styleGuide, onClose }: { styleGuide?: StyleGuide; onClose: () => void }) => {
    const [modifiedSummary, setModifiedSummary] = useState<string>(styleGuide?.summary?.text ?? '');
    const [isLoading, setIsLoading] = useState(false);

    const { saveStyleGuides } = useStyleGuideContext();

    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (styleGuide) {
            setModifiedSummary(styleGuide.summary.text);

            if (textAreaRef.current) {
                textAreaRef.current.focus();
            }
        }
    }, [styleGuide]);

    if (styleGuide === undefined) {
        return null;
    }

    const onSave = async () => {
        setIsLoading(true);

        const response = await saveStyleGuides([{ id: styleGuide.id, summary: modifiedSummary }]);

        if ('error' in response) {
            showToast({ type: 'error', title: 'Error while saving summary. Please try again.' });
            setIsLoading(false);

            return;
        }

        setIsLoading(false);

        onClose();
    };

    return (
        <ConfirmModal
            opened
            size="wide"
            title="AI summary"
            confirmText="Save"
            onClose={onClose}
            onConfirm={onSave}
            loading={isLoading}
        >
            <Textarea
                ref={textAreaRef}
                rows={15}
                value={modifiedSummary}
                onChange={(e) => setModifiedSummary(e.target.value)}
            />
        </ConfirmModal>
    );
};

export default EditSummaryModal;
